export const checkEnglishValidation = (_: any, text: string): boolean => {
	try {
		if (!text?.trim()) return false;

		const englishRegex = /^[A-Za-z0-9\s.,!?;:'"()\-\[\]_@#$%^&*+=/\\|~`<>«»]+$/;

		return englishRegex.test(text);
	} catch {
		return false;
	}
};
